import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { Button, Card, CardBody, Table } from "reactstrap"
import { useDispatch } from "react-redux"
import { Trash } from "lucide-react"
import Paginations from "components/Common/Pagination"
import NoDataAvailable from "components/Shared/NoDataAvailable"
import { usePermissions } from "../../../hooks"
import DeleteModal from "../../../components/Common/DeleteModal"
import { showAlert } from "../../../store/reducers/alertReducer"
import { deleteTrialOperationInspection } from "../../../store/actions/trialPeriodAction"
import InspectionAttendanceModal from "./InspectionAttendanceModal"
import { deleteRandomCheck } from "store/actions/roasterAction"

const headers = [
  "S. No.",
  "Station",
  "Shift",
  "Job Title",
  "Name",
  "National ID",
  "Random Checker",
  "Status",
  "Date",
  // "Reason",
  "Remarks",
  "Action",
]

const InspectionTable = ({
  onPageChange,
  data,
  currentPage,
  perPage,
  totalPages,
  totalCount,
  trigger,
  loading,
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [selectedInspection, setSelectedInspection] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const { showAll, permissions } = usePermissions("trial_run")
  const [expandedRowId, setExpandedRowId] = useState(null)
  const [isOpenInspectionAttendanceModal, setIsOpenInspectionAttendanceModal] =
    useState(false)

  const handleDelete = async () => {
    dispatch(deleteRandomCheck(selectedInspection))
      .then(action => {
        const { statusCode, success, message } = action.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          trigger()
          setShowDeleteModal(false)
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(error => {
        console.log("error", error)
      })
  }

  return (
    <>
      <Card className="overflow-x-auto">
        <CardBody>
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light full_th">
                <tr>
                  {headers.map((header, index) => (
                    <th
                      key={index}
                      style={
                        header === "Job Title" ||
                        header === "Name" ||
                        header === "Check In" ||
                        header === "Check Out"
                          ? { minWidth: "165px", whiteSpace: "nowrap" }
                          : header === "Date"
                          ? { minWidth: "99px", whiteSpace: "nowrap" }
                          : undefined
                      }
                    >
                      {t(header)}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={item.id}>
                    <th scope="row">
                      {(currentPage - 1) * perPage + index + 1}
                    </th>
                    <td>{item?.station}</td>
                    <td>{item?.shift}</td>
                    <td>{item?.assign_job_title}</td>
                    <td>
                      <p>{item?.user?.name}</p>
                    </td>
                    <td>{item?.user?.national_id}</td>
                    <td>{item?.captured_by}</td>
                    <td>
                      {item.status === 1
                        ? t("Present")
                        : item.status === 2
                        ? t("Absent")
                        : ""}
                    </td>
                    <td>{item?.captured_at?.split(" ")[0]}</td>
                    <td
                      onClick={() =>
                        setExpandedRowId(
                          expandedRowId === item.id ? null : item.id
                        )
                      }
                      style={{
                        maxWidth: "150px",
                        cursor: "pointer",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace:
                          expandedRowId === item.id ? "normal" : "nowrap",
                        wordBreak: "break-word",
                      }}
                      title="Click to expand"
                    >
                      {item.remark || "-"}
                    </td>
                    <td>
                      <div className="d-flex gap-2 action_buttons">
                        {(showAll || permissions.includes("can_delete")) && (
                          <Button
                            color="danger"
                            onClick={() => {
                              setSelectedInspection(item.id)
                              setShowDeleteModal(true)
                            }}
                            disabled={
                              loading && item.uuid === setSelectedTrailOp
                            }
                            title={t("Delete")}
                          >
                            <Trash />
                          </Button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {!loading && data.length === 0 && <NoDataAvailable />}
        </CardBody>
      </Card>
      {data.length !== 0 && (
        <Paginations
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalCount}
          onPageChange={onPageChange}
        />
      )}
      <DeleteModal
        show={showDeleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={() => {
          setSelectedInspection(null)
          setShowDeleteModal(false)
        }}
        isLoading={loading}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to delete this Random Check?")}
      />
      {isOpenInspectionAttendanceModal && (
        <InspectionAttendanceModal
          isOpen={isOpenInspectionAttendanceModal}
          toggle={() => {
            setIsOpenInspectionAttendanceModal(false)
            setTrigger(!trigger)
          }}
        />
      )}
    </>
  )
}

export default InspectionTable
